import { createSlice } from '@reduxjs/toolkit';
import { addNewCurrency, editCurrency, getAllCurrencies } from './currencyService';

const initialState = {
  allCurrencies: {
    isCurrenciesLoading: null,
    isCurrenciesSuccess: null,
    currenciesMessage: null,
    currencies: [],
  },
  newCurrency: {
    isCurrencyCreating: null,
    isCurrencyCreated: null,
    currencyCreationMsg: null,
  },

  editedCurrency: {
    isEditingCurrency: null,
    isCurrencyEdited: null,
    currencyEditedMsg: null
  }
};

const currencySlice = createSlice({
  name: 'currency',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllCurrencies.pending, (state) => {
        state.allCurrencies = {
          ...initialState.allCurrencies, // Reset to initial state
          isCurrenciesLoading: true,
          currenciesMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllCurrencies.rejected, (state, action) => {
        state.allCurrencies = {
          ...initialState.allCurrencies,
          isCurrenciesLoading: false,
          isCurrenciesSuccess: false,
          currenciesMessage: action.payload || 'Error occurred while fetching currencies',
        };
      })

      // FULFILLED
      .addCase(getAllCurrencies.fulfilled, (state, action) => {
        state.allCurrencies = {
          ...initialState.allCurrencies,
          isCurrenciesLoading: false,
          isCurrenciesSuccess: true,
          currencies: action.payload || [],
        };
      });

    //Currency creating
    builder
      .addCase(addNewCurrency.pending, (state) => {
        state.newCurrency = {
          ...initialState.newCurrency, // Reset to initial state
          isCurrencyCreating: true,
          currencyCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewCurrency.rejected, (state, action) => {
        state.newCurrency = {
          ...initialState.newCurrency,
          isCurrencyCreating: false,
          isCurrencyCreated: false,
          currencyCreationMsg: action.payload || 'Error occurred while creating the currency.',
        };
      })

      // FULFILLED
      .addCase(addNewCurrency.fulfilled, (state, action) => {
        state.newCurrency = {
          ...initialState.newCurrency,
          isCurrencyCreating: false,
          isCurrencyCreated: true,
          currencyCreationMsg: action.payload || 'Successfully created the currency.',
        };
      });

    //Currency editing
    builder
      .addCase(editCurrency.pending, (state) => {
        state.editedCurrency = {
          ...initialState.editedCurrency, // Reset to initial state
          isEditingCurrency: true,
          currencyEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editCurrency.rejected, (state, action) => {
        state.editedCurrency = {
          ...initialState.editedCurrency, // Reset to initial state
          isEditingCurrency: false,
          isCurrencyEdited: false,
          currencyEditedMsg: action.payload || 'Error occurred while editing the currency.',
        };
      })

      // FULFILLED
      .addCase(editCurrency.fulfilled, (state, action) => {
        state.editedCurrency = {
          ...initialState.editedCurrency, // Reset to initial state
          isEditingCurrency: false,
          isCurrencyEdited: true,
          currencyEditedMsg: action.payload || 'Successfully edited the currency.',
        };
      });
  },
});

export default currencySlice.reducer;
